export const regionCardsImages = [
  {
    banner: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/vertical_slider_webp/image/catalog/a/5dc144a793ca4.jpeg`,
    map: `https://villatravellers-prod.s3.eu-west-2.amazonaws.com/assets/images/maps/sicily-north.png`,
  },
  {
    banner: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/vertical_slider_webp/image/catalog/a/5dc1440d1c0a2.jpeg`,
    map: `https://villatravellers-prod.s3.eu-west-2.amazonaws.com/assets/images/maps/sicily-west.png`,
  },
  {
    banner: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/vertical_slider_webp/image/catalog/a/5dc144b24468d.jpeg`,
    map: `https://villatravellers-prod.s3.eu-west-2.amazonaws.com/assets/images/maps/sicily-east.png`,
  },
  {
    banner: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/vertical_slider_webp/image/catalog/a/5dc144bccb4ea.jpeg`,
    map: `https://villatravellers-prod.s3.eu-west-2.amazonaws.com/assets/images/maps/sicily-south.png`,
  },
];

export const villaCardsImages = [
  {
    banner: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/menu_card_3x_webp/image/static/destinations/sicily-small%403x.jpg`,
    map: `https://villatravellers-prod.s3.eu-west-2.amazonaws.com/assets/images/maps/sicily-full.png`,
  },
  {
    banner: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/menu_card_3x_webp/image/static/destinations/puglia-small%403x.jpg`,
    map: `https://www.villatravellers.com/assets/images/maps/puglia-full.738b2126.png`,
  },
];

export const guideCardsImages = [
  {
    banner: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/menu_card_3x_webp/image/static/travel-guide/sicily-guide-bg%402x.png`,
    srcset: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/menu_card_3x_webp/image/static/travel-guide/sicily-guide-bg%402x.png 1200w ,${process.env.NEXT_PUBLIC_S3_URI}/thumbs/menu_card_2x_webp/image/static/travel-guide/sicily-guide-bg%402x.png 800w ,${process.env.NEXT_PUBLIC_S3_URI}/thumbs/menu_card_webp/image/static/travel-guide/sicily-guide-bg%402x.png 400w`,
  },
  {
    banner: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/menu_card_3x_webp/image/static/travel-guide/travelto-bg%402x.png`,
    srcset: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/menu_card_3x_webp/image/static/travel-guide/travelto-bg%402x.png 1200w ,${process.env.NEXT_PUBLIC_S3_URI}/thumbs/menu_card_2x_webp/image/static/travel-guide/travelto-bg%402x.png 800w ,${process.env.NEXT_PUBLIC_S3_URI}/thumbs/menu_card_webp/image/static/travel-guide/travelto-bg%402x.png 400w`,
  },
  {
    banner: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/menu_card_3x_webp/image/static/travel-guide/puglia-guide-bg%402x.png`,
    srcset: `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/menu_card_3x_webp/image/static/travel-guide/puglia-guide-bg%402x.png 1200w ,${process.env.NEXT_PUBLIC_S3_URI}/thumbs/menu_card_2x_webp/image/static/travel-guide/puglia-guide-bg%402x.png 800w ,${process.env.NEXT_PUBLIC_S3_URI}/thumbs/menu_card_webp/image/static/travel-guide/puglia-guide-bg%402x.png 400w`,
  },
];
